import { render, staticRenderFns } from "./PhotowallResizeComponent.vue?vue&type=template&id=aae5074c&"
import script from "./PhotowallResizeComponent.vue?vue&type=script&lang=js&"
export * from "./PhotowallResizeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhotowallResizeComponent.vue?vue&type=style&index=0&id=aae5074c&prod&lang=scss&"
import style1 from "./PhotowallResizeComponent.vue?vue&type=style&index=1&id=aae5074c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports